module.exports = __webpack_public_path__ + "img/8-8.5d75fe6a.png";